import * as React from 'react';
import renderDataTest from '../../utilities/testAutomation';

const Parser = require('html-react-parser');

interface Props {
  term: string;
  content: string;
  parentContainer?: HTMLDivElement;
  dataTest?: string;
}

interface State {
  rect: ClientRect;
  containerRect: ClientRect;
}

class GlossaryTooltip extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      rect: {} as ClientRect,
      containerRect: {} as ClientRect,
    };
    this.glossaryTerm = React.createRef();
    this._getRectangles = this._getRectangles.bind(this);
  }

  componentDidMount() {
    this._getRectangles();
    window.addEventListener('resize', this._getRectangles);
  }

  componentDidUpdate({ parentContainer: prevParentContainer }: Props) {
    const { parentContainer } = this.props;
    if (parentContainer !== prevParentContainer) {
      this._getRectangles();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._getRectangles);
  }

  private glossaryTerm: any;

  private _getRectangles = () => {
    const { parentContainer } = this.props;
    const rect = this.glossaryTerm.current.getBoundingClientRect();
    const containerRect = parentContainer ? parentContainer.getBoundingClientRect() : {} as ClientRect;
    this.setState({ rect, containerRect });
  }

  private _getStyles = (rect: ClientRect, containerRect: ClientRect) => {
    const popoverBottom = (containerRect.bottom - rect.top - 7) || 0;
    const triangleLeft = (rect.left - containerRect.left - 36 + (rect.width / 2)) || 0;

    return {
      popover: { bottom: window.innerWidth < 1133 ? popoverBottom : '2.5em' },
      triangle: { left: window.innerWidth < 1133 ? triangleLeft : '152px' },
    };
  }

  render() {
    const {
      term,
      content,
      dataTest,
    } = this.props;
    const { rect, containerRect } = this.state;
    const styles = this._getStyles(rect, containerRect);

    return (
      <span className="glossary-tooltip-wrapper" {...dataTest && renderDataTest(dataTest, 'wrapper')}>
        <span className="glossary" ref={this.glossaryTerm}>
          {term}
        </span>
        <span className="popover-content" {...dataTest && renderDataTest(dataTest, 'content')} style={styles.popover}>
          <span className="triangle" style={styles.triangle} />
          {Parser(content)}
        </span>
      </span>
    );
  }
}

export default GlossaryTooltip;



// WEBPACK FOOTER //
// ./src/components/GlossaryTooltip/GlossaryTooltip.tsx